import React, { Component } from 'react'
import { Form, DatePicker, Input, Button, Popconfirm, message, Spin } from 'antd'
import moment from 'moment'
import { validateDate } from '../util'

const FormItem = Form.Item
const propTypes = {}

class ScheduleManufacturingDatesView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false
    }
  }

  componentWillUnmount() {
    this.props.clearHighlight()
  }

  handleSaveDatesClick = () => {
    const form = this.props.form

    form.validateFields((err, values) => {
      if (err) {
        return
      }

      let transformedDates = {}
      let scheduleType = null
      let scheduleDescription = null
      const currentDates = this.props.data
      Object.keys(values).forEach(function(key, value) {
        if (values[key] !== null) {
          if (moment.isMoment(values[key])) {
            if (!moment(values[key]).isSame(currentDates[key])) {
              scheduleType = key
            }
          }
        }
        transformedDates[key] = validateDate(values[key])
      })
      this.props.updateManufacturingDates({
        jobId: this.props.jobId,
        scheduleId: this.props.machineIndex,
        userId: this.props.userId,
        content: transformedDates,
        scheduleType: scheduleType,
        description: scheduleDescription
      })

      form.resetFields()
      this.props.clearFields()
    })
    this.setState({
      isEditing: false
    })
  }

  handleNotesBlur = e => {
    this.props.updateNotes({
      jobId: this.props.jobId,
      scheduleId: this.props.machineIndex,
      userId: this.props.userId,
      notes: e.target.value
    })
    message.success('Notes saved.')
  }

  handleCancelEditClick = () => {
    this.props.clearFields()
  }

  cancelDelete = () => {
    this.props.clearFields()
  }

  confirmDelete = () => {
    this.props.deleteSchedule(this.props.machineIndex)
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { data, isEditing } = this.props

    if (!data) {
      return <Spin size="large" />
    }

    return (
      <div>
        <Form layout="vertical">
          <div className="row sceduleTitleRow">
            <div className="col-md-9">
              {!isEditing && <h2>{data.name}</h2>}
              {isEditing && (
                <div>
                  <FormItem>
                    {getFieldDecorator('name', {
                      rules: [
                        {
                          required: true,
                          message: 'Schedule device must have a name.'
                        }
                      ],
                      initialValue: data.name
                    })(<Input />)}
                  </FormItem>
                </div>
              )}
            </div>
            <div className="col-md-3">
              {isEditing && (
                <div className="datesButtonArea">
                  <Button type="primary" icon="save" onClick={() => this.handleSaveDatesClick()} />
                  <Button
                    type="default"
                    icon="close"
                    className="marginRight10"
                    onClick={() => this.handleCancelEditClick()}
                  />
                </div>
              )}
            </div>
          </div>
          {data && (
            <div>
              {/* LINE 1 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">CRL Sent</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('crl_sent_date', {
                        initialValue: moment(data.crl_sent_date).isValid()
                          ? moment(data.crl_sent_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.crl_sent_date !== null
                        ? moment(data.crl_sent_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">CRL Received</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('crl_received_date', {
                        initialValue: moment(data.crl_received_date).isValid()
                          ? moment(data.crl_received_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.crl_received_date !== null
                        ? moment(data.crl_received_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4" />
              </div>

              {/* LINE 2 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Release for Manufacturing</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('release_for_manufacturing_date', {
                        initialValue: moment(data.release_for_manufacturing_date).isValid()
                          ? moment(data.release_for_manufacturing_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.release_for_manufacturing_date !== null
                        ? moment(data.release_for_manufacturing_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4" />
                <div className="col-4" />
              </div>

              {/* LINE 3 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Requested Shipment</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('requested_shipment_date', {
                        initialValue: moment(data.requested_shipment_date).isValid()
                          ? moment(data.requested_shipment_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.requested_shipment_date !== null
                        ? moment(data.requested_shipment_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Estimated Shipment</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('estimated_shipment_date', {
                        initialValue: moment(data.estimated_shipment_date).isValid()
                          ? moment(data.estimated_shipment_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.estimated_shipment_date !== null
                        ? moment(data.estimated_shipment_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Confirmed Shipment</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('confirmed_shipment_date', {
                        initialValue: moment(data.confirmed_shipment_date).isValid()
                          ? moment(data.confirmed_shipment_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.confirmed_shipment_date !== null
                        ? moment(data.confirmed_shipment_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
              </div>

              {/* LINE 4 */}
              <div className="row padding10-all">
                <div className="col-4">
                  <div className="jobDetailsHeader">Estimated Delivery</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('estimated_delivery_date', {
                        initialValue: moment(data.estimated_delivery_date).isValid()
                          ? moment(data.estimated_delivery_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.estimated_delivery_date !== null
                        ? moment(data.estimated_delivery_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4">
                  <div className="jobDetailsHeader">Confirmed Delivery</div>
                  {this.props.isEditing && (
                    <FormItem>
                      {getFieldDecorator('confirmed_delivery_date', {
                        initialValue: moment(data.confirmed_delivery_date).isValid()
                          ? moment(data.confirmed_delivery_date)
                          : null
                      })(<DatePicker />)}
                    </FormItem>
                  )}
                  {!this.props.isEditing && (
                    <div>
                      {data.confirmed_delivery_date !== null
                        ? moment(data.confirmed_delivery_date).format('MM/D/YYYY')
                        : 'Not Entered'}
                    </div>
                  )}
                </div>
                <div className="col-4" />
              </div>
              <div className="row">
                <div className="col-md-12 text-right">
                  <Popconfirm
                    title="Are you sure you want to delete this schedule?"
                    onConfirm={this.confirmDelete}
                    onCancel={this.cancelDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button className="marginRight20" type="danger" icon="delete" />
                  </Popconfirm>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    )
  }
}

ScheduleManufacturingDatesView.propTypes = propTypes
export default Form.create()(ScheduleManufacturingDatesView)



// WEBPACK FOOTER //
// ./src/components/ScheduleManufacturingDatesView.js